import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { BaseContainer } from 'secondstep-components'
import { Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'

export const HeaderParagraph = styled(ReactMarkdown)`
  color: ${themeGet('colors.darkGray')};
  font-family: ${themeGet('fontFamily')};
  font-size: 1rem;
  margin-top: 0.75rem;
  p {
    margin: 0;
  }

  a {
    color: ${themeGet('colors.darkGray')};
  }
`

export const Header2 = styled.p`
  color: ${themeGet('colors.highschool.green2')};
  font-family: ${themeGet('font.komet')};
  font-weight: bold;
  font-size: 1.25rem;
  margin: 0;
`

export const StyledContainer = styled(BaseContainer).attrs(() => ({
  as: 'section',
}))`
  margin-top: 1.25rem;
  padding: 1.75rem;
  max-width: 85.375rem;
  border: 2px solid ${themeGet('colors.highschool.green3')};
  position: relative;
  &:hover {
    border: 2px solid ${themeGet('colors.themePrimary')};
  }
  ${themeGet('breakpoints.mobileLarge')} {
    padding: 1.75rem 1rem;
  }
`

export const StyledLinkWrapper = styled(Link)`
  text-decoration: none;
`

export const MainLayoutContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
`

export const ContentWrapper = styled.div`
  flex: 1;
`

export const CompletionCircle = styled.div`
  width: 1.0625rem;
  height: 1.0625rem;
  border-radius: 50%;
  border: 1.5px solid
    ${props =>
      props.markedComplete
        ? themeGet('colors.highschool.green5')
        : themeGet('colors.darkGray')};
  background-color: ${props =>
    props.markedComplete
      ? themeGet('colors.highschool.green5')
      : 'transparent'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 0.25rem;
`

export const CompletionCheckmark = styled.img`
  width: 0.75rem;
  height: 0.75rem;
`

export const HeaderTagsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
`

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`

export const Tag = styled.div`
  background-color: ${themeGet('colors.aliceBlue')};
  color: ${themeGet('colors.darkGray')};
  border-radius: 0.25rem;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 500;
  font-family: ${themeGet('font.molde.regular')};
  line-height: 1;
`

export const TagText = styled.span`
  color: ${themeGet('colors.darkGray')};
`
